export function formatDateForDatePicker(date: Date | string) {
  if (!date || date === "") {
    return "";
  }

  let internalDate: Date;
  if (date instanceof Date) {
    internalDate = date;
  } else {
    internalDate = new Date(date);
  }

  if (isNaN(internalDate.getTime())) {
    return "";
  }

  const day = String(internalDate.getUTCDate()).padStart(2, "0");
  const month = String(internalDate.getUTCMonth() + 1).padStart(2, "0");
  const year = internalDate.getUTCFullYear();

  return `${day}/${month}/${year}`;
}
